import { ImageDisplay } from '@/components/Dialogs/ImageDisplay';
import { RedirectExternal } from '@/components/Dialogs/Redirect';
import ErrorBoundary from '@/ErrorBoundary';
import type { Embed } from 'types';

type BorderColor = string | undefined;
export default function EmbedContent({ embed }: { embed: Embed }) {


    const makeHex = (color: string) => {
        const colorInt = parseInt(color, 10);

        const hexString = colorInt.toString(16).padStart(6, '0');

        return `#${hexString}`;
    }

    const youtubeVideoRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    return (
        <ErrorBoundary>
            <div className="border-l-4 shadow-lg px-4 py-4 bg-brand-dark rounded w-auto sm:w-full sm:max-w-full max-w-90 space-y-2" style={{ borderColor: embed?.color ? makeHex(embed?.color?.toString()) as BorderColor : "#2f333a" }}>

                <div className='justify-between flex  gap-2'>
                    <div className="flex flex-col gap-2">
                        {embed?.author && (
                            <div className="flex items-start gap-2">
                                {embed.author.icon_url && (
                                    <img src={`${import.meta.env.VITE_IMAGE_PROXY}/proxy?url=${embed.author.icon_url}`} className="w-6 h-6 rounded-full" onError={(e) => {
                                        e.currentTarget.style.display = 'none';
                                    }} />
                                )}
                                <p className="font-semibold text-white">{embed.author.name}</p>
                            </div>
                        )}
                        {embed?.title && (
                            <>
                                <div className='items-start flex w-64 sm:w-full'>
                                    {embed.url ? (
                                        <RedirectExternal link={embed.url}>
                                            <span className="font-semibold text-blue-400 hover:cursor-pointer">{embed.title}</span>
                                        </RedirectExternal>
                                    ) : (
                                        <p className="font-semibold text-white">{embed.title}</p>
                                    )}
                                </div>
                            </>
                        )}
                        {embed?.description && (
                            <p className="text-white text-sm flex break-all whitespace-pre-wrap">
                                {embed.description}
                            </p>
                        )}
                        {embed?.fields && embed.fields.map((field, index) => (
                            <div key={index} className="flex flex-col gap-1">
                                <p className="font-semibold text-white">{field.name}</p>
                                <p className="text-white">{field.value}</p>
                            </div>
                        ))}
                        {
                            embed?.url && youtubeVideoRegex.test(embed.url) && (
                                <div className="flex items-start  gap-2">
                                    <iframe
                                        src={`https://www.youtube-nocookie.com/embed/${youtubeVideoRegex.exec(embed.url)![1]}?modestbranding=1`}
                                        className='w-60 sm:w-auto sm:min-w-96 sm:min-h-64 rounded-lg'
                                        allowFullScreen
                                        loading='lazy'
                                    ></iframe>
                                </div>
                            )
                        }

                        {embed?.image && (
                            <div className='w-auto'>
                                <ImageDisplay url={`${import.meta.env.VITE_IMAGE_PROXY}/proxy?url=${embed.image.url}`} >
                                    <img src={`${import.meta.env.VITE_IMAGE_PROXY}/proxy?url=${embed.image.url}`} className="cursor-pointer sm:max-w-[20rem] object-cover rounded-lg" onError={(e) => {
                                        e.currentTarget.style.display = 'none';
                                    }} />
                                </ImageDisplay>
                            </div>
                        )}

                        {embed?.footer && (
                            <div className="flex items-start gap-2">
                                {embed.footer.icon_url && (
                                    <img src={`${import.meta.env.VITE_IMAGE_PROXY}/proxy?url=${embed.footer.icon_url}`} className="w-6 h-6 rounded-full" onError={(e) => {
                                        e.currentTarget.style.display = 'none';
                                    }} />
                                )}
                                <p className="text-sm">{embed.footer.text}</p>
                            </div>
                        )}

                    </div>
                    <div className="items-start right-0 top-0 gap-2">
                        {embed?.thumbnail && (
                            <ImageDisplay url={`${import.meta.env.VITE_IMAGE_PROXY}/proxy?url=${embed.thumbnail.url}`}>
                                <img src={`${import.meta.env.VITE_IMAGE_PROXY}/proxy?url=${embed.thumbnail.url}`} className="max-w-32 max-h-16 rounded-lg cursor-pointer" onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                }} />
                            </ImageDisplay>
                        )}
                    </div>
                </div>
            </div>
        </ErrorBoundary>
    );
}